import Avatar, { AvatarProps } from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";

import { getUserInitials } from "common";
import { colors } from "theme";

interface UserAvatarProps extends Omit<Partial<AvatarProps>, "alt" | "sx"> {
  name: string;
  role?: string;
}

export const UserAvatar = ({ name, role, ...props }: UserAvatarProps) => {
  return (
    <Badge
      badgeContent={role}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: colors.blackTransparent,
          color: colors.white,
          right: "51%",
          bottom: "12.5%",
          fontSize: "0.6875rem",
          height: "1rem"
        }
      }}
    >
      <Avatar {...props} alt={name}>
        {getUserInitials(name).toUpperCase()}
      </Avatar>
    </Badge>
  );
};
